<template>
  <v-main>
    <v-list dense nav>
      <v-list-item-action>
        <v-btn @click="changeToFrench()" class="d-md-flex ma-2" plain>
          fr
        </v-btn>

        <v-divider inset vertical></v-divider>

        <v-btn @click="changeToEnglish()" class="ma-2" plain>
          en
        </v-btn>
      </v-list-item-action>
    </v-list>
    <v-alert dense shaped color="teal" icon="mdi-clock-fast" class="v-alert">
      {{ $vuetify.lang.t("$vuetify.waitingMobile") }}
    </v-alert>
  </v-main>
</template>

<script>
export default {
  name: "WaitingMobile",

  methods: {
    changeToFrench() {
      this.$vuetify.lang.current = "fr";
    },

    changeToEnglish() {
      this.$vuetify.lang.current = "en";
    }
  }
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Epilogue&display=swap");
.v-alert {
  width: 80%;
  margin: auto;
  position: relative;
  top: 50px;
}
</style>
